// extracted by mini-css-extract-plugin
export var icon = "_4m-1";
export var subtext = "_4m-0";